export enum PaymentMethods {
  ElectronicFundTransfer = "EFT",
  CheckOrMoneyOrder = "CHK",
  Check = "CHQ",
  MoneyOrder = "MORD",
  DirectBill = "DB",
  CreditCard = "CC",
}
